import axios from 'axios'
import { useApiClient } from '@/composables/api-client'
import type { ApiClientCallConfig } from '@/composables/api-client/types'
import { expiredSessionInterceptor, gatewayTimeoutInterceptor, misleadingHtmlResponseInterceptor } from '../helpers'

const envVars = import.meta.env
const testMode = envVars.MODE === 'test'
const baseUrl = envVars.VITE_BUILDER_DEV_API_URL || envVars.VITE_BUILDER_API_URL

export const builderAxiosInstance = axios.create({
    baseURL: baseUrl.replace(/\/+$/, ''),
    withCredentials: true,
})

!testMode && builderAxiosInstance.interceptors.response.use(
    misleadingHtmlResponseInterceptor,
    async (error) => {
        return await expiredSessionInterceptor(error, builderAxiosInstance)
    },
)

!testMode && builderAxiosInstance.interceptors.response.use(
    (res) => res,
    async (error) => {
        return await gatewayTimeoutInterceptor(error)
    },
)

export function useBuilderApiClient<T, D = ANY>(config: ApiClientCallConfig<D>) {
    return useApiClient<T, D>(config, builderAxiosInstance)
}
